export default "__VITE_ASSET__BH1lOs9z__"